interface TablePageSelectedCountIndicatorProps {
  selectedCount: number;
  totalCount: number;
}

export function TablePageSelectedCountIndicator({ selectedCount, totalCount }: TablePageSelectedCountIndicatorProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <span className="text-default-text px-2 text-sm">
      {selectedCount} / {totalCount} selected
    </span>
  );
}
